import { useLocation } from 'react-router-dom';

export default function useQuerySearchParams(): URLSearchParams {
  return new URLSearchParams(useLocation().search);
}
